/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ExpectedTransactionType {
    ISSUE = 'ISSUE',
    TRANSFER = 'TRANSFER',
    REDEMPTION = 'REDEMPTION',
    CANCELLATION = 'CANCELLATION',
}
